/**
 * Format the supplied `bytes` to a human-readable string.
 * @param {number} bytes The value to convert.
 * @param {number} [decimals=2] The maximum number of decimals to include in the result string.
 * @returns {string} A human-readable representation of the `bytes` value.
 */
const formatBytes = ( bytes, decimals = 2 ) => {
    if ( bytes === 0 ) return '0 Bytes';
    const k = 1024,
        sizes = [ 'Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB' ],
        i = Math.floor( Math.log( bytes ) / Math.log( k ) );
    return parseFloat( ( bytes / Math.pow( k, i ) ).toFixed( decimals ) ) + ' ' + sizes[ i ];
};

export default formatBytes;